module.exports = __webpack_public_path__ + "img/Project1-2.bbab824b.png";